class En
{
    constructor()
    {
        this.general = {
            prospective: "Prospective",
            student: "Student",
            alumni: "Alumni",
            parent: "Parent",
            person: "Person",
            staff: "Teacher",
        }

        this.organization = {
            edu: "Faculty of Education",
            ait: "Faculty of Agricultural Technology and Industrial Technology",
            hss: "Faculty of Humanities and Social Sciences",
            ms: "Faculty of Management Sciences",
            sci: "Faculty of Science and Technology",
            op: "Office of President",
            apr: "The Office of Academic Promotion and Registration",
            aritc: "Academic Resources and Information Technology Center",
            artculture: "Nakhon Sawan Art and Cultual Office",
            rdi: "Research and Development Institute",
        }

        this.mainmenu = {
            home: "Home",

            intro: "About",
            organization: "Faculties",
            education: "Education",
            service: "Services",

            forProspective: "Prospective",
            forStudent: "Student",
            forAlumni: "Alumni",
            forParent: "Parent",
            forPerson: "Person",
            forStaff: "Teacher & Staff",

            otherOrganization: "Other Organization",
        }
    }
}

export default En
